import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { environment } from "../../../environment";
import ConnectedProduct from "../productTeaser/ConnectedProduct";

// Semantic banner size → Bootstrap column span + aspect ratio (mirrors the FTL bannerSizeStyle).
// Bootstrap rows can't span vertical grid tracks, so "tall"/"hero" express height via aspect-ratio
// instead of a row span.
const BANNER_LAYOUT = {
    regular: { col: "col-xl-4 col-sm-6", aspectRatio: "1 / 1" },
    wide: { col: "col-xl-8 col-sm-12", aspectRatio: "2 / 1" },
    tall: { col: "col-xl-4 col-sm-6", aspectRatio: "1 / 2" },
    hero: { col: "col-xl-8 col-sm-12", aspectRatio: "16 / 10" },
    full: { col: "col-12", aspectRatio: "4 / 1" },
};

// External commerce images are already absolute; a merchandising banner is a JCR DAM link
// (/dam/jcr:…) relative to the Magnolia host — prefix the base so it resolves from the :3000 origin.
const bannerImgSrc = (link) => (!link ? "" : /^(https?:)?\/\//i.test(link) ? link : environment.MAGNOLIA_BASE_URL + link);

const MerchandisingBanner = ({ link, size }) => {
    const layout = BANNER_LAYOUT[size] || BANNER_LAYOUT.regular;
    return (
        <div className={`${layout.col} mb-25`}>
            <div style={{ position: "relative", overflow: "hidden", borderRadius: 8, aspectRatio: layout.aspectRatio }}>
                <img
                    src={bannerImgSrc(link)}
                    alt=""
                    loading="lazy"
                    style={{ display: "block", width: "100%", height: "100%", objectFit: "cover" }}
                />
            </div>
        </div>
    );
};

const ProductGrid = ({ products, layout }) => {
    const isList = layout === "list";

    return (
        <Fragment>
            {products.map((product) => {
                if (product.__banner) {
                    return <MerchandisingBanner key={product["@id"]} link={product.link} size={product.size} />;
                }
                return (
                    <div key={product["@id"]} className={isList ? "col-12 mb-25" : "col-xl-4 col-sm-6 mb-25"}>
                        <ConnectedProduct product={product} layout={layout} />
                    </div>
                );
            })}
        </Fragment>
    );
};

ProductGrid.propTypes = {
    layout: PropTypes.string,
    products: PropTypes.array,
};

export default ProductGrid;
